import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { FORM_TYPES } from '../../../../types/paramsConfig.js';
import { navigateTo, selectActiveForm, } from '../../../../core/navigation/navigationSlice.js';
import { trackButtonClick } from '../../../../tracking/index.js';
import { twoStepActiveStateSelector, trackingTwoStepLoginRegistrationStateSelector, updateTwoStepActiveState, } from '../../../TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
import { isTwoStep } from '../../../../tracking/helpers/constants.js';
export const ForgotPasswordLink = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const activeForm = useAppSelector(selectActiveForm);
    const twoStepActiveState = useAppSelector(twoStepActiveStateSelector);
    const twoStepComponentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    const showResetPasswordModal = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'forgotPassword',
            ...(isTwoStep(activeForm) && { componentState: twoStepComponentState }),
        }));
        if (twoStepActiveState === 'login' || isTwoStep(activeForm)) {
            dispatch(updateTwoStepActiveState('resetPassword'));
        }
        else {
            dispatch(navigateTo(FORM_TYPES.RESET_PASSWORD));
        }
    };
    return (_jsx(Button, { "data-testid": "forgot-password-link", a11yLabel: "butn", variant: "link", size: ['small'], onClick: showResetPasswordModal, children: t('loginregistration.login.forgotPassword') }));
};
//# sourceMappingURL=ForgotPasswordLink.js.map